import L, { Map, DomUtil, Evented } from 'leaflet'
import { get, find, popupToContent } from '@ttungbmt/utils'
import _ from 'lodash-es'
import axios from "axios";
import { getWMSLayers } from "@ttungbmt/geo";
import Source from "@ttungbmt/leaflet-source";

const BASEMAP = 'basemap'

/**
 * Leaflet.MapBuilder
 * @author Trương Thanh Tùng
 * @license MIT
 */

function removeMapDiv(dom) {
    let container = DomUtil.get(dom)
    if (container) {
        container._leaflet_id = null;
    }
}

class MapBuilder extends Evented {
    /**
     * @param  {Object, HTMLElement, string id} mapObject
     * @return {Object}
     */
    initialize(map, builder = {}) {
        this.builder = builder

        this._setMap(map)
        this._setBuilder(builder)
        this.onEvents()
    }

    _setMap(map) {
        if (map instanceof Map) {
            this.map = map
        } else {
            removeMapDiv(map)
            let mapOptions = get(this.builder, 'options.map')
            console.log(mapOptions);
            this.map = L.map(map, mapOptions)
        }
    }

    _setBuilder({config = {}, layers, controls}) {
        this._setConfig(config)
        this._setLayers(layers)
        this._setControls(controls)
    }

    _setConfig(config) {
        const {center, zoom = 10, maxZoom, minZoom, maxBounds} = config

        center && this.setView(center, zoom)
        maxZoom && this.map.setMaxZoom(maxZoom)
        minZoom && this.map.setMinZoom(minZoom)
        maxBounds && this.map.setMaxBounds(maxBounds)
    }

    _setLayers(items) {
        const filterLayers = (filter) => _.chain(items)
            .filter(filter)
            .mapKeys('title')
            .mapValues(l => {
                let source = new Source(l.type, l.options.url, Object.assign({uuid: l.uuid}, l.options))
                return l.active ? source._layer.addTo(this.map) : source._layer
            })
            .value()

        const baseLayers = filterLayers(i => i.control === BASEMAP)
        const overlay = filterLayers(i => i.control !== BASEMAP)

        L.control.layers(baseLayers, overlay).addTo(this.map);
    }

    _setControls(controls) {

    }

    onEvents() {
        this.map.on('click', ({latlng}) => {
            this._showFeatureInfo(latlng)
        })
    }

    _showFeatureInfo(latlng) {
        getWMSLayers(this.map).map(l => {
            const url = `/admin/mapbuilder/default/client?url=` + encodeURIComponent(l.getFeatureInfoUrl(latlng))
            axios.get(url).then(({data}) => {
                console.log(data);
                let feature = get(data, 'features.0.properties')
                if (feature) {
                    let template = get(find(this.builder.layers, {uuid: l.uuid}), 'popupTemplate', '')
                    if (template) {
                        let content = popupToContent(template, feature)
                        let popup = L.popup().setLatLng(latlng).setContent(content).openOn(this.map)
                    }
                }
            }).catch(e => {
                console.warn(e);
            })
        })
    }

    invalidateSize(options) {
        this.map.invalidateSize(options)
    }

    setView(center, zoom, options) {
        this.map.setView(center, zoom, options)
    }

    fitWorld(options) {
        this.map.fitWorld(options)
    }

    panTo(latlng, options) {
        this.map.panTo(latlng, options)
    }

    flyTo(latlng, zoom, options) {
        this.map.flyTo(latlng, zoom, options)
    }

    flyToBounds(bounds, options) {
        this.map.flyToBounds(bounds, options)
    }
}

L.map.builder = function (map, builder) {
    return new MapBuilder(map, builder);
}

export default MapBuilder